import React from 'react';
import { Hero } from '../components/Hero';
import { EmotionalIntro } from '../components/EmotionalIntro';
import { ProblemSection } from '../components/ProblemSection';
import { WhyFailedSection } from '../components/WhyFailedSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetails } from '../components/ProductDetails';
import { TargetAudience } from '../components/TargetAudience';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white selection:bg-red-600 selection:text-white" data-id="element-172">
      <Hero data-id="element-173" />
      <EmotionalIntro data-id="element-174" />
      <ProblemSection data-id="element-175" />
      <WhyFailedSection data-id="element-176" />
      <SolutionSection data-id="element-177" />
      <ProductDetails data-id="element-178" />
      <TargetAudience data-id="element-179" />
      <HowItWorks data-id="element-180" />
      <FAQ data-id="element-181" />
      <FinalCTA data-id="element-182" />
    </main>;
}